import { render } from "./AddProductPage.vue?vue&type=template&id=ca2c9276"
import script from "./AddProductPage.vue?vue&type=script&lang=js"
export * from "./AddProductPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__